import React, { useState } from "react";
import "tippy.js/dist/tippy.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "./USDT.scss";
import Loading from "../../../../component/Loading/Loading";
import { getFromlocalstorage } from "../../../../component/MaHoaDuLieu";
import ModalUSDT from "../../../../Layout/DefaultLayout/Account/NapTien/ModalUsdt/ModalUsdt";

const USDT = () => {
  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const userData = JSON.parse(getFromlocalstorage("data_u"));

  const [selecteditem, setselecteditem] = useState("onlinebank");
  const [isOpen, setisOpen] = useState(false);
  const [warn, setwarn] = useState("");
  const [tienvalue, settienvalue] = useState("");
  const [loading, setLoading] = useState(false);
  const [depositData, setDepositData] = useState(null);
  const method = [
    {
      name: "onlinebank",
      image: "/caidat/usdt.png",
      image_noactive: "/caidat/onlinebanknoactive.png",
    },
  ];

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success(" คัดลอกสำเร็จ", {
        position: "top-right",
        autoClose: 3000,
      });
    });
  };

  const handleSubmit = async () => {
    const num = parseFloat(tienvalue);

    if (isNaN(num)) {
      setwarn("กรุณากรอกจำนวนเงินที่ถูกต้อง.");
      return;
    }
    if (num < 10) {
      setwarn("จำนวนเงินขั้นต่ำคือ 10 USDT.");
      return;
    }
    if (num > 50000) {
      setwarn("จำนวนเงินสูงสุดคือ 50,000 USDT.");
      return;
    }
    setwarn("");
    setLoading(true);

    try {
      const res = await fetch(`${apiUrl}/naptien/${userData._id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: num,
          type: "deposit-crypto",
        }),
      });
      const data = await res.json();

      if (res.ok) {
        setDepositData(data);
        setisOpen(true); // mở popup QR sau khi thành công
      } else {
        toast.error(data.message || "ฝาก USDT ไม่สำเร็จ.");
      }
    } catch (err) {
      toast.error("เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tab-content_nap">
      <ToastContainer position="top-right" autoClose={3000} />
      <Loading isLoading={loading} />

      <div className="list-group-depoin">
        <div className="box-right-depoins">
          <form action="">
            <div className="pay_wrap_tructuyen">
              <div className="pay_listtructuyen_title">
                  วิธีการฝากเงิน::
              </div>

              <div className="pay_listtructuyen">
                {method.map((item, index) => (
                  <a
                    className={`pay_listtructuyen_item ${
                      selecteditem === item.name
                        ? "pay_listtructuyen_item_active"
                        : ""
                    }`}
                    key={index}
                    onClick={() => setselecteditem(item.name)}
                  >
                    <i
                      style={{
                        background: `url(${
                          selecteditem === item.name
                            ? item.image
                            : item.image_noactive
                        }) 50% no-repeat`,
                      }}
                      className="pay_listtructuyen_item_icon"
                    ></i>
                    <span className="pay_listtructuyen_item_title">
                      USDT - TRC20
                    </span>
                  </a>
                ))}
              </div>

              <div className="divdichiviqr">
                <div className="divdichiviqr_cell">
                  <div className="divdichiviqr_cell_title">ที่อยู่</div>
                  <div className="divdichiviqr_cell_content">
                    TBaV2R1hubhG3VnX4vZ6ZgiCV6HPZMBDqu
                  </div>
                  <div
                    className="divdichiviqr_cell_copy"
                    onClick={() =>
                      handleCopy("TBaV2R1hubhG3VnX4vZ6ZgiCV6HPZMBDqu")
                    }
                  >
                      คัดลอก
                  </div>
                 
                </div>
                <div className="divdichiviqr_cell">
                  <div className="divdichiviqr_cell_title">หมายเหตุ</div>
                  <div className="divdichiviqr_cell_content">
                      กรุณากรอก ID ธุรกรรมให้ถูกต้อง และแนบรูปภาพการทำรายการสำเร็จ
                  </div>
                </div>
              </div>
            </div>

            <div className="divinput_usdt">
              <div className="pay_listtructuyen_title">จำนวนเงิน</div>

              <div
                className={`div_amount_cell ${
                  warn ? "div_amount_cell_error" : ""
                }`}
              >
                <div className="div_amount_cell_item">
                  <span className="prefix_icon_usdt"></span>
                  <input
                    type="tel"
                    className="input_usdt_nap"
                    placeholder="10 - 50,000"
                    value={tienvalue}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                        "Delete",
                      ];
                      const isNumberKey = /^[0-9]$/.test(e.key);
                      if (!isNumberKey && !allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "") {
                        setwarn("");
                      } else if (Number(value) < 10 || Number(value) > 50000) {
                        setwarn("วงเงินคือ 10 - 50,000");
                      } else {
                        setwarn("");
                      }
                      settienvalue(value);
                    }}
                  />
                </div>
                <div className="div_amount_cell_item exchanged_usdt">
                  <span className="exchanged_usdt_span_one"></span>
                  <span className="exchanged_usdt_span_two">
                    {(tienvalue * 34).toLocaleString("en-US")}
                  </span>
                </div>
              </div>
            </div>

            {warn && (
              <div className="divwarn_usdt rech_warn report">
                <div>
                  <i></i>
                  {warn}
                </div>
              </div>
            )}

            <div className="divwarn_usdt rech_warn">
              <div>
                <i></i>
                  อัตราแลกเปลี่ยน 1:34
              </div>
            </div>
          </form>
        </div>
      </div>

      <div className="footer_nap_submit">
        <div className="footer_nap_submit_btn">
          <button
            type="button"
            className="footer_nap_submit_btn_submit"
            onClick={handleSubmit}
          >
            ยืนยันการฝากเงิน
          </button>
        </div>
      </div>

      <ModalUSDT
        isOpen={isOpen}
        setisOpen={() => setisOpen(false)}
        amount={parseFloat(tienvalue) || 0}
        depositData={depositData}
      />
    </div>
  );
};

export default USDT;
